import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8d680d9c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d680d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d680d9c')) {
      api.createRecord('8d680d9c', component.options)
    } else {
      api.reload('8d680d9c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8d680d9c&scoped=true", function () {
      api.rerender('8d680d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/route/managementMailingRules/index.vue"
export default component.exports